import type QueryBuilder from '@/helpers/models/QueryBuilder'
import type { Model } from '@/helpers/models/Model'
import { Filter, type FilterOp } from './Filter'

export type FilterType = 'boolean'

export class FilterControl<FilterModel extends Model> {
	key: string
	name: string
	icon: string
	type: FilterType
	queryUpdateHandler?: (qb: QueryBuilder<FilterModel>) => QueryBuilder<FilterModel>

	constructor(params: {
		key: string
		name: string
		icon: string
		type?: FilterType
		queryUpdateHandler?: (
			this: Filter<FilterModel>,
			qb: QueryBuilder<FilterModel>,
		) => QueryBuilder<FilterModel>
	}) {
		this.key = params.key
		this.name = params.name
		this.icon = params.icon
		this.type = params.type ?? 'boolean'
		this.queryUpdateHandler = params.queryUpdateHandler
	}

	defaultFilter(params?: { operator: FilterOp }) {
		return new Filter<FilterModel>({
			key: this.key,
			operator: params?.operator ?? 'is',
			updateQuery: this.queryUpdateHandler,
		})
	}
}
